module.exports = __webpack_public_path__ + "static/media/students-icon-1.ddc19dd9.svg";